import './assets/css/main.scss';

import share from './data/share.json';

import { loadDone, progress } from './preload';
import { initShareButtons } from './js/share';
import { initShareButtons as initResultShareButtons } from './js/shareResult';
import { SnakeMain } from './js/SnakeMain';
import { initScrollBars } from './js/scrollbars';
import { initViewPortHeightVar } from './js/viewportHeightVar';

initShareButtons('.footer .share__item', share.result);
initResultShareButtons('.result .share__item', share.result);

window.addEventListener('load', async () => {
    initScrollBars();
    initViewPortHeightVar();

    const main = new SnakeMain();

    await main.start(progress);

    progress(1);

    loadDone();

    console.log('--- Cache testing message ---');
});
